export default Object.freeze({
  // NOTE:
  // Constants for async action creators are in ./async
  // Constants for sync / UI action creators are in ./sync

  // ***********************************************************************************
  // CART
  GET_CART_SUCCESS: 'GET_CART_SUCCESS',
  UPDATE_CART_PENDING: 'UPDATE_CART_PENDING',
  UPDATE_CART_SUCCESS: 'UPDATE_CART_SUCCESS',
  UPDATE_REMOTE_CART_SUCCESS: 'UPDATE_REMOTE_CART_SUCCESS',
  UPDATE_REMOTE_CART_FAILURE: 'UPDATE_REMOTE_CART_FAILURE',
  UPDATE_CART_FAILURE: 'UPDATE_CART_FAILURE',
  CLEAR_CART_SUCCESS: 'CLEAR_CART_SUCCESS',
  CALCULATE_CART: 'CALCULATE_CART',
  CALCULATE_CART_PENDING: 'CALCULATE_CART_PENDING',
  CALCULATE_CART_FULFILLED: 'CALCULATE_CART_FULFILLED',
  CALCULATE_CART_REJECTED: 'CALCULATE_CART_REJECTED',
  FETCH_CART_DETAILS: 'FETCH_CART_DETAILS',
  FETCH_CART_DETAILS_PENDING: 'FETCH_CART_DETAILS_PENDING',
  FETCH_CART_DETAILS_FULFILLED: 'FETCH_CART_DETAILS_FULFILLED',
  FETCH_CART_DETAILS_REJECTED: 'FETCH_CART_DETAILS_REJECTED',
  CLEAR_CART_VALIDATION: 'CLEAR_CART_VALIDATION',
  PRODUCT_ADDED_TO_CART: 'PRODUCT_ADDED_TO_CART',

  // ***********************************************************************************
  // CURRENT USER DETAILS
  FETCH_PROFILE: 'FETCH_PROFILE',
  FETCH_PROFILE_PENDING: 'FETCH_PROFILE_PENDING',
  FETCH_PROFILE_FULFILLED: 'FETCH_PROFILE_FULFILLED',
  FETCH_PROFILE_REJECTED: 'FETCH_PROFILE_REJECTED',

  // ***********************************************************************************
  // CATEGORY
  FETCH_CATEGORY: 'FETCH_CATEGORY',
  FETCH_CATEGORY_PENDING: 'FETCH_CATEGORY_PENDING',
  FETCH_CATEGORY_FULFILLED: 'FETCH_CATEGORY_FULFILLED',
  FETCH_CATEGORY_REJECTED: 'FETCH_CATEGORY_REJECTED',

  // ***********************************************************************************
  // CATEGORIES
  FETCH_CATEGORIES: 'FETCH_CATEGORIES',
  FETCH_CATEGORIES_PENDING: 'FETCH_CATEGORIES_PENDING',
  FETCH_CATEGORIES_FULFILLED: 'FETCH_CATEGORIES_FULFILLED',
  FETCH_CATEGORIES_REJECTED: 'FETCH_CATEGORIES_REJECTED',

  // ***********************************************************************************
  // FREIGHT_GROUP
  FETCH_FREIGHT_GROUP: 'FETCH_FREIGHT_GROUP',
  FETCH_FREIGHT_GROUP_PENDING: 'FETCH_FREIGHT_GROUP_PENDING',
  FETCH_FREIGHT_GROUP_FULFILLED: 'FETCH_FREIGHT_GROUP_FULFILLED',
  FETCH_FREIGHT_GROUP_REJECTED: 'FETCH_FREIGHT_GROUP_REJECTED',

  // ***********************************************************************************
  // INVOICES
  FETCH_INVOICES: 'FETCH_INVOICES',
  PAY_INVOICE_REQUEST: 'PAY_INVOICE_REQUEST',
  NOTIFY_PAY_INVOICE_REQUEST: 'NOTIFY_PAY_INVOICE_REQUEST',
  NOTIFY_PAY_INVOICE_SUCCESS: 'NOTIFY_PAY_INVOICE_SUCCESS',
  NOTIFY_PAY_INVOICE_ERROR: 'NOTIFY_PAY_INVOICE_ERROR',
  PAY_INVOICE_SUCCESS: 'PAY_INVOICE_SUCCESS',
  PAY_INVOICE_ERROR: 'PAY_INVOICE_ERROR',
  FETCH_INVOICES_PENDING: 'FETCH_INVOICES_PENDING',
  FETCH_INVOICES_FULFILLED: 'FETCH_INVOICES_FULFILLED',
  FETCH_INVOICES_REJECTED: 'FETCH_INVOICES_REJECTED',
  FETCH_INVOICE_DETAILS: 'FETCH_INVOICE',
  FETCH_INVOICE_DETAILS_PENDING: 'FETCH_INVOICE_PENDING',
  FETCH_INVOICE_DETAILS_FULFILLED: 'FETCH_INVOICE_FULFILLED',
  FETCH_INVOICE_DETAILS_REJECTED: 'FETCH_INVOICE_REJECTED',
  CLEAR_INVOICES: 'CLEAR_INVOICES',

  // ***********************************************************************************
  // CARTS
  FETCH_CARTS: 'FETCH_CARTS',
  FETCH_CARTS_PENDING: 'FETCH_CARTS_PENDING',
  FETCH_CARTS_FULFILLED: 'FETCH_CARTS_FULFILLED',
  FETCH_CARTS_REJECTED: 'FETCH_CARTS_REJECTED',

  // ***********************************************************************************
  // MARKETPLACES
  FETCH_MARKETPLACES: 'FETCH_MARKETPLACES',
  FETCH_MARKETPLACES_PENDING: 'FETCH_MARKETPLACES_PENDING',
  FETCH_MARKETPLACES_FULFILLED: 'FETCH_MARKETPLACES_FULFILLED',
  FETCH_MARKETPLACES_REJECTED: 'FETCH_MARKETPLACES_REJECTED',

  // ***********************************************************************************
  // PAYMENT METHOD DETAILS
  FETCH_PAYMENT_METHOD_DETAILS: 'FETCH_PAYMENT_METHOD_DETAILS',
  FETCH_PAYMENT_METHOD_DETAILS_PENDING: 'FETCH_PAYMENT_METHOD_DETAILS_PENDING',
  FETCH_PAYMENT_METHOD_DETAILS_FULFILLED:
    'FETCH_PAYMENT_METHOD_DETAILS_FULFILLED',
  FETCH_PAYMENT_METHOD_DETAILS_REJECTED:
    'FETCH_PAYMENT_METHOD_DETAILS_REJECTED',

  FETCH_PAYMENT_DETAILS: 'FETCH_PAYMENT_DETAILS',
  FETCH_PAYMENT_DETAILS_PENDING: 'FETCH_PAYMENT_DETAILS_PENDING',
  FETCH_PAYMENT_DETAILS_FULFILLED: 'FETCH_PAYMENT_DETAILS_FULFILLED',
  FETCH_PAYMENT_DETAILS_REJECTED: 'FETCH_PAYMENT_DETAILS_REJECTED',

  // ***********************************************************************************
  // PAYMENT METHODS
  FETCH_PAYMENT_METHODS: 'FETCH_PAYMENT_METHODS',
  FETCH_PAYMENT_METHODS_PENDING: 'FETCH_PAYMENT_METHODS_PENDING',
  FETCH_PAYMENT_METHODS_FULFILLED: 'FETCH_PAYMENT_METHODS_FULFILLED',
  FETCH_PAYMENT_METHODS_REJECTED: 'FETCH_PAYMENT_METHODS_REJECTED',

  // PAYMENTS
  FETCH_PAYMENTS: 'FETCH_PAYMENTS',
  FETCH_PAYMENTS_PENDING: 'FETCH_PAYMENTS_PENDING',
  FETCH_PAYMENTS_FULFILLED: 'FETCH_PAYMENTS_FULFILLED',
  FETCH_PAYMENTS_REJECTED: 'FETCH_PAYMENTS_REJECTED',

  // ***********************************************************************************
  // PRODUCT DETAILS
  FETCH_PRODUCT_DETAILS: 'FETCH_PRODUCT_DETAILS',
  FETCH_PRODUCT_DETAILS_PENDING: 'FETCH_PRODUCT_DETAILS_PENDING',
  FETCH_PRODUCT_DETAILS_FULFILLED: 'FETCH_PRODUCT_DETAILS_FULFILLED',
  FETCH_PRODUCT_DETAILS_REJECTED: 'FETCH_PRODUCT_DETAILS_REJECTED',

  // ***********************************************************************************
  // PRODUCTS
  FETCH_PRODUCTS: 'FETCH_PRODUCTS',
  FETCH_PRODUCTS_PENDING: 'FETCH_PRODUCTS_PENDING',
  FETCH_PRODUCTS_FULFILLED: 'FETCH_PRODUCTS_FULFILLED',
  FETCH_PRODUCTS_REJECTED: 'FETCH_PRODUCTS_REJECTED',
  CLEAR_PRODUCTS: 'CLEAR_PRODUCTS',

  // ***********************************************************************************
  // TRENDING
  FETCH_TRENDING_PRODUCTS: 'FETCH_TRENDING_PRODUCTS',
  FETCH_TRENDING_PRODUCTS_PENDING: 'FETCH_TRENDING_PRODUCTS_PENDING',
  FETCH_TRENDING_PRODUCTS_FULFILLED: 'FETCH_TRENDING_PRODUCTS_FULFILLED',
  FETCH_TRENDING_PRODUCTS_REJECTED: 'FETCH_TRENDING_PRODUCTS_REJECTED',
  CLEAR_TRENDING_PRODUCTS: 'CLEAR_TRENDING_PRODUCTS',

  // ***********************************************************************************
  // MOST_ORDERED
  FETCH_MOST_ORDERED_PRODUCTS: 'FETCH_MOST_ORDERED_PRODUCTS',
  FETCH_MOST_ORDERED_PRODUCTS_PENDING: 'FETCH_MOST_ORDERED_PRODUCTS_PENDING',
  FETCH_MOST_ORDERED_PRODUCTS_FULFILLED:
    'FETCH_MOST_ORDERED_PRODUCTS_FULFILLED',
  FETCH_MOST_ORDERED_PRODUCTS_REJECTED: 'FETCH_MOST_ORDERED_PRODUCTS_REJECTED',
  CLEAR_MOST_ORDERED_PRODUCTS: 'CLEAR_MOST_ORDERED_PRODUCTS',

  // ***********************************************************************************
  // PURCHASER DETAILS
  FETCH_PURCHASER_DETAILS: 'FETCH_PURCHASER_DETAILS',
  FETCH_PURCHASER_DETAILS_PENDING: 'FETCH_PURCHASER_DETAILS_PENDING',
  FETCH_PURCHASER_DETAILS_FULFILLED: 'FETCH_PURCHASER_DETAILS_FULFILLED',
  FETCH_PURCHASER_DETAILS_REJECTED: 'FETCH_PURCHASER_DETAILS_REJECTED',

  // ***********************************************************************************
  // RETAILER DETAILS
  FETCH_RETAILER_DETAILS: 'FETCH_RETAILER_DETAILS',
  FETCH_RETAILER_DETAILS_PENDING: 'FETCH_RETAILER_DETAILS_PENDING',
  FETCH_RETAILER_DETAILS_FULFILLED: 'FETCH_RETAILER_DETAILS_FULFILLED',
  FETCH_RETAILER_DETAILS_REJECTED: 'FETCH_RETAILER_DETAILS_REJECTED',

  // ***********************************************************************************
  // RETAILERS
  FETCH_RETAILERS: 'FETCH_RETAILERS',
  FETCH_RETAILERS_PENDING: 'FETCH_RETAILERS_PENDING',
  FETCH_RETAILERS_FULFILLED: 'FETCH_RETAILERS_FULFILLED',
  FETCH_RETAILERS_REJECTED: 'FETCH_RETAILERS_REJECTED',

  // ***********************************************************************************
  // ORDER DETAILS
  FETCH_ORDER_DETAILS: 'FETCH_ORDER_DETAILS',
  FETCH_ORDER_DETAILS_PENDING: 'FETCH_ORDER_DETAILS_PENDING',
  FETCH_ORDER_DETAILS_FULFILLED: 'FETCH_ORDER_DETAILS_FULFILLED',
  FETCH_ORDER_DETAILS_REJECTED: 'FETCH_ORDER_DETAILS_REJECTED',

  // ***********************************************************************************
  // ORDERS
  FETCH_ORDERS: 'FETCH_ORDERS',
  FETCH_ORDERS_PENDING: 'FETCH_ORDERS_PENDING',
  FETCH_ORDERS_FULFILLED: 'FETCH_ORDERS_FULFILLED',
  FETCH_ORDERS_REJECTED: 'FETCH_ORDERS_REJECTED',
  FETCH_DELIVERY_DATES: 'FETCH_DELIVERY_DATES',
  FETCH_DELIVERY_DATES_PENDING: 'FETCH_DELIVERY_DATES_PENDING',
  FETCH_DELIVERY_DATES_FULFILLED: 'FETCH_DELIVERY_DATES_FULFILLED',
  FETCH_DELIVERY_DATES_REJECTED: 'FETCH_DELIVERY_DATES_REJECTED',
  CREATE_ORDER: 'CREATE_ORDER',
  CREATE_ORDER_PENDING: 'CREATE_ORDER_PENDING',
  CREATE_ORDER_FULFILLED: 'CREATE_ORDER_FULFILLED',
  CREATE_ORDER_REJECTED: 'CREATE_ORDER_REJECTED',
  CLEAR_ORDERS: 'CLEAR_ORDERS',
  UPDATE_LAST_FETCHED_PAGE: 'UPDATE_LAST_FETCHED_PAGE',
  NOTIFY_UPDATE_ORDER_SUCCESS: 'NOTIFY_UPDATE_ORDER_SUCCESS',
  NOTIFY_UPDATE_ORDER_ERROR: 'NOTIFY_UPDATE_ORDER_ERROR',

  // ***********************************************************************************
  // PAYMENT FORM
  GET_CARD_TYPE: 'GET_CARD_TYPE',
  GET_CARD_TYPE_PENDING: 'GET_CARD_TYPE_PENDING',
  GET_CARD_TYPE_FULFILLED: 'GET_CARD_TYPE_FULFILLED',
  GET_CARD_TYPE_REJECTED: 'GET_CARD_TYPE_REJECTED',

  VALIDATE_CARD: 'VALIDATE_CARD',
  VALIDATE_CARD_PENDING: 'VALIDATE_CARD_PENDING',
  VALIDATE_CARD_FULFILLED: 'VALIDATE_CARD_FULFILLED',
  VALIDATE_CARD_REJECTED: 'VALIDATE_CARD_REJECTED',

  ADD_NEW_CARD: 'ADD_NEW_CARD',
  ADD_NEW_CARD_PENDING: 'ADD_NEW_CARD_PENDING',
  ADD_NEW_CARD_FULFILLED: 'ADD_NEW_CARD_FULFILLED',
  ADD_NEW_CARD_REJECTED: 'ADD_NEW_CARD_REJECTED',
  DEBIT_CREDIT_CARD_SAVE_CLICKED: 'DEBIT_CREDIT_CARD_SAVE_CLICKED',

  UPDATE_CARD_NUMBER: 'UPDATE_CARD_NUMBER',
  UPDATE_EXPIRY_DATE: 'UPDATE_EXPIRY_DATE',
  UPDATE_SECURITY_CODE: 'UPDATE_SECURITY_CODE',
  UPDATE_NAME: 'UPDATE_NAME',
  UPDATE_FIRST_NAME: 'UPDATE_FIRST_NAME',
  UPDATE_LAST_NAME: 'UPDATE_LAST_NAME',

  UPDATE_DEFAULT_PAYMENT: 'UPDATE_DEFAULT_PAYMENT',
  UPDATE_ACKNOWLEDGEMENT: 'UPDATE_ACKNOWLEDGEMENT',

  CLEAR_CARD_DETAILS: 'CLEAR_CARD_DETAILS',

  UPDATE_ACCOUNT_NAME: 'UPDATE_ACCOUNT_NAME',
  UPDATE_BSB: 'UPDATE_BSB',
  UPDATE_ACCOUNT_NUMBER: 'UPDATE_ACCOUNT_NUMBER',
  UPDATE_DEFAULT_PAYMENT_DIRECT: 'UPDATE_DEFAULT_PAYMENT_DIRECT',
  CLEAR_DIRECT_DEBIT_DETAILS: 'CLEAR_DIRECT_DEBIT_DETAILS',
  UPDATE_FIRST_SIGNATORY: 'UPDATE_FIRST_SIGNATORY',
  UPDATE_SECOND_SIGNATORY: 'UPDATE_SECOND_SIGNATORY',

  ADD_NEW_DIRECT_DEBIT: 'ADD_NEW_DIRECT_DEBIT',
  ADD_NEW_DIRECT_DEBIT_PENDING: 'ADD_NEW_DIRECT_DEBIT_PENDING',
  ADD_NEW_DIRECT_DEBIT_FULFILLED: 'ADD_NEW_DIRECT_DEBIT_FULFILLED',
  ADD_NEW_DIRECT_DEBIT_REJECTED: 'ADD_NEW_DIRECT_DEBIT_REJECTED',

  DELETE_PAYMENT_METHOD: 'DELETE_PAYMENT_METHOD',
  DELETE_PAYMENT_METHOD_PENDING: 'DELETE_PAYMENT_METHOD_PENDING',
  DELETE_PAYMENT_METHOD_FULFILLED: 'DELETE_PAYMENT_METHOD_FULFILLED',
  DELETE_PAYMENT_METHOD_REJECTED: 'DELETE_PAYMENT_METHOD_REJECTED',

  TOGGLE_DEFAULT_PAYMENT: 'TOGGLE_DEFAULT_PAYMENT',
  TOGGLE_DEFAULT_PAYMENT_PENDING: 'TOGGLE_DEFAULT_PAYMENT_PENDING',
  TOGGLE_DEFAULT_PAYMENT_FULFILLED: 'TOGGLE_DEFAULT_PAYMENT_FULFILLED',
  TOGGLE_DEFAULT_PAYMENT_REJECTED: 'TOGGLE_DEFAULT_PAYMENT_REJECTED',

  // ***********************************************************************************
  // FAVOURITES
  FETCH_FAVOURITES: 'FETCH_FAVOURITES',
  FETCH_FAVOURITES_PENDING: 'FETCH_FAVOURITES_PENDING',
  FETCH_FAVOURITES_FULFILLED: 'FETCH_FAVOURITES_FULFILLED',
  FETCH_FAVOURITES_REJECTED: 'FETCH_FAVOURITES_REJECTED',
  CLEAR_FAVOURITES: 'CLEAR_FAVOURITES',
  FETCH_FAVOURITE_DETAILS: 'FETCH_FAVOURITE_DETAILS',
  FETCH_FAVOURITE_DETAILS_PENDING: 'FETCH_FAVOURITE_DETAILS_PENDING',
  FETCH_FAVOURITE_DETAILS_FULFILLED: 'FETCH_FAVOURITE_DETAILS_FULFILLED',
  FETCH_FAVOURITE_DETAILS_REJECTED: 'FETCH_FAVOURITE_DETAILS_REJECTED',
  UPDATE_FAVOURITE: 'UPDATE_FAVOURITE',
  UPDATE_FAVOURITE_PENDING: 'UPDATE_FAVOURITE_PENDING',
  UPDATE_FAVOURITE_FULFILLED: 'UPDATE_FAVOURITE_FULFILLED',
  UPDATE_FAVOURITE_REJECTED: 'UPDATE_FAVOURITE_REJECTED',
  DELETE_FAVOURITE: 'DELETE_FAVOURITE',
  DELETE_FAVOURITE_PENDING: 'DELETE_FAVOURITE_PENDING',
  DELETE_FAVOURITE_FULFILLED: 'DELETE_FAVOURITE_FULFILLED',
  DELETE_FAVOURITE_REJECTED: 'DELETE_FAVOURITE_REJECTED',
  CLEAR_FAVOURITE_DETAILS: 'CLEAR_FAVOURITE_DETAILS',

  // ***********************************************************************************
  // SCHEDULES
  FETCH_PURCHASER_SCHEDULES: 'FETCH_PURCHASER_SCHEDULES',
  FETCH_PURCHASER_SCHEDULES_PENDING: 'FETCH_PURCHASER_SCHEDULES_PENDING',
  FETCH_PURCHASER_SCHEDULES_FULFILLED: 'FETCH_PURCHASER_SCHEDULES_FULFILLED',
  FETCH_PURCHASER_SCHEDULES_REJECTED: 'FETCH_PURCHASER_SCHEDULES_REJECTED',
  UPDATE_PURCHASER_SCHEDULE_PLACE_STATUS:
    'UPDATE_PURCHASER_SCHEDULE_PLACE_STATUS',
  UPDATE_PURCHASER_SCHEDULE_PLACE_STATUS_PENDING:
    'UPDATE_PURCHASER_SCHEDULE_PLACE_STATUS_PENDING',
  UPDATE_PURCHASER_SCHEDULE_PLACE_STATUS_FULFILLED:
    'UPDATE_PURCHASER_SCHEDULE_PLACE_STATUS_FULFILLED',
  UPDATE_PURCHASER_SCHEDULE_PLACE_STATUS_REJECTED:
    'UPDATE_PURCHASER_SCHEDULE_PLACE_STATUS_REJECTED',
  UPDATE_PURCHASER_SCHEDULE_FAVOURITES: 'UPDATE_PURCHASER_SCHEDULE_FAVOURITES',
  UPDATE_PURCHASER_SCHEDULE_FAVOURITES_PENDING:
    'UPDATE_PURCHASER_SCHEDULE_FAVOURITES_PENDING',
  UPDATE_PURCHASER_SCHEDULE_FAVOURITES_FULFILLED:
    'UPDATE_PURCHASER_SCHEDULE_FAVOURITES_FULFILLED',
  UPDATE_PURCHASER_SCHEDULE_FAVOURITES_REJECTED:
    'UPDATE_PURCHASER_SCHEDULE_FAVOURITES_REJECTED',
  CANCEL_NEXT_DELIVERY_SCHEDULE: 'CANCEL_NEXT_DELIVERY_SCHEDULE',
  CANCEL_NEXT_DELIVERY_SCHEDULE_PENDING:
    'CANCEL_NEXT_DELIVERY_SCHEDULE_PENDING',
  CANCEL_NEXT_DELIVERY_SCHEDULE_FULFILLED:
    'CANCEL_NEXT_DELIVERY_SCHEDULE_FULFILLED',
  CANCEL_NEXT_DELIVERY_SCHEDULE_REJECTED:
    'CANCEL_NEXT_DELIVERY_SCHEDULE_REJECTED',
  STOP_SCHEDULE_NOTIFICATION: 'STOP_SCHEDULE_NOTIFICATION',
  STOP_SCHEDULE_NOTIFICATION_PENDING: 'STOP_SCHEDULE_NOTIFICATION_PENDING',
  STOP_SCHEDULE_NOTIFICATION_FULFILLED: 'STOP_SCHEDULE_NOTIFICATION_FULFILLED',
  STOP_SCHEDULE_NOTIFICATION_REJECTED: 'STOP_SCHEDULE_NOTIFICATION_REJECTED',
  ADD_TO_NEXT_DELIVERY_SCHEDULE: 'ADD_TO_NEXT_DELIVERY_SCHEDULE',
  ADD_TO_NEXT_DELIVERY_SCHEDULE_PENDING:
    'ADD_TO_NEXT_DELIVERY_SCHEDULE_PENDING',
  ADD_TO_NEXT_DELIVERY_SCHEDULE_FULFILLED:
    'ADD_TO_NEXT_DELIVERY_SCHEDULE_FULFILLED',
  ADD_TO_NEXT_DELIVERY_SCHEDULE_REJECTED:
    'ADD_TO_NEXT_DELIVERY_SCHEDULE_REJECTED',
  FETCH_ORDER_PROJECTIONS: 'FETCH_ORDER_PROJECTIONS',
  FETCH_ORDER_PROJECTIONS_PENDING: 'FETCH_ORDER_PROJECTIONS_PENDING',
  FETCH_ORDER_PROJECTIONS_FULFILLED: 'FETCH_ORDER_PROJECTIONS_FULFILLED',
  FETCH_ORDER_PROJECTIONS_REJECTED: 'FETCH_ORDER_PROJECTIONS_REJECTED',

  // ***********************************************************************************
  // TERMS AND CONDITIONS
  FETCH_TERMS_AND_CONDITIONS: 'FETCH_TERMS_AND_CONDITIONS',
  FETCH_TERMS_AND_CONDITIONS_FULFILLED: 'FETCH_TERMS_AND_CONDITIONS_FULFILLED',
  FETCH_TERMS_AND_CONDITIONS_PENDING: 'FETCH_TERMS_AND_CONDITIONS_PENDING',
  FETCH_TERMS_AND_CONDITIONS_REJECTED: 'FETCH_TERMS_AND_CONDITIONS_REJECTED',
  ACCEPT_TERMS_AND_CONDITIONS: 'ACCEPT_TERMS_AND_CONDITIONS',
  ACCEPT_TERMS_AND_CONDITIONS_PENDING: 'ACCEPT_TERMS_AND_CONDITIONS_PENDING',
  ACCEPT_TERMS_AND_CONDITIONS_FULFILLED:
    'ACCEPT_TERMS_AND_CONDITIONS_FULFILLED',
  ACCEPT_TERMS_AND_CONDITIONS_REJECTED: 'ACCEPT_TERMS_AND_CONDITIONS_REJECTED',
  TERMS_AND_CONDITIONS_MODAL: 'terms-and-conditions-modal',

  // see note at top of file

  // ***********************************************************************************

  // OTHER VALUES
  TABLET_BREAKPOINT: 1024,
  TABLET_BREAKPOINT_MIN: 768,
  MOBILE_BREAKPOINT: 480,

  PRODUCT_DESCRIPTION_LENGTH_MOBILE: 100,
  PRODUCT_DESCRIPTION_LENGTH_DESKTOP: 200,

  // SETTINGS TAB
  SETTINGS_TAB: [
    {
      name: 'Payment Settings',
      link: 'payment',
      icon: 'payment-settings',
    },
    {
      name: 'User Settings',
      link: 'profile',
      icon: 'user-settings',
    },
    {
      name: 'Venue Settings',
      link: 'venues',
      icon: 'venue-settings',
    },
  ],

  NOOP: () => {},
  NOOP_PROMISE: () => Promise.resolve(),
  DATE_FORMAT: 'ddd Do MMM YYYY [at] h:mm a',
  DATE_FORMAT_TIMELESS: 'ddd Do MMM YYYY',
  DATE_FORMAT_SHORT: 'DD/MM/YY',
  DATE_FORMAT_SHORT_WITH_TIME: 'DD/MM/YY [at] h:mm a',
  DATE_FORMAT_DAY_TIME: 'dddd h:mm a',

  // USER AGENT
  SET_UA: 'SET_UA',
  // SOCKETS
  SET_SOCKET_ID: 'SET_SOCKET_ID',

  // EXPORTS
  QUEUE_EXPORT_REQUEST: 'QUEUE_EXPORT_REQUEST',
  QUEUE_EXPORT_SUCCESS: 'QUEUE_EXPORT_SUCCESS',
  QUEUE_EXPORT_ERROR: 'QUEUE_EXPORT_ERROR',
  NOTIFY_WEBSOCKET_MESSAGE_SUCCESS: 'NOTIFY_WEBSOCKET_MESSAGE_SUCCESS',

  // PDF TYPES
  PDF_TYPE_INVOICE_PDF: 'invoice_pdf',
  PDF_TYPE_INVOICE_EXPORT_PDF: 'invoice_export_pdf',
  PDF_TYPE_CREDIT_NOTES_PDF: 'credit_notes_pdf',

  // NOTIFICATIONS
  NOTIFY_ADD_NEW_CARD_SUCCESS: 'NOTIFY_ADD_NEW_CARD_SUCCESS',
  NOTIFY_ADD_NEW_CARD_FAILURE: 'NOTIFY_ADD_NEW_CARD_FAILURE',
  NOTIFY_ADD_NEW_DIRECT_SUCCESS: 'NOTIFY_ADD_NEW_DIRECT_SUCCESS',
  NOTIFY_ADD_NEW_DIRECT_FAILURE: 'NOTIFY_ADD_NEW_DIRECT_FAILURE',
  TOGGLE_DEFAULT_PAYMENT_SUCCESS: 'TOGGLE_DEFAULT_PAYMENT_SUCCESS',
  TOGGLE_DEFAULT_PAYMENT_FAILURE: 'TOGGLE_DEFAULT_PAYMENT_FAILURE',
  DELETE_PAYMENT_METHOD_SUCCESS: 'DELETE_PAYMENT_METHOD_SUCCESS',
  DELETE_PAYMENT_METHOD_FAILURE: 'DELETE_PAYMENT_METHOD_FAILURE',
  NOTIFY_DELETE_PAYMENT_METHOD_SUCCESS: 'NOTIFY_DELETE_PAYMENT_METHOD_SUCCESS',
  NOTIFY_DELETE_PAYMENT_METHOD_FAILURE: 'NOTIFY_DELETE_PAYMENT_METHOD_FAILURE',
  NOTIFY_IMAGE_UPLOAD_ERROR: 'NOTIFY_IMAGE_UPLOAD_ERROR',
  NOTIFY_IMAGE_UPLOAD_SUCCESS: 'NOTIFY_IMAGE_UPLOAD_SUCCESS',
  ORDER_CREATION_FAILURE: 'ORDER_CREATION_FAILURE',
  UPDATE_CART_SUCCESS_NOTIFICATION: 'UPDATE_CART_SUCCESS_NOTIFICATION',
  UPDATE_CART_FAILURE_NOTIFICATION: 'UPDATE_CART_FAILURE_NOTIFICATION',
  CLEAR_CART_SUCCESS_NOTIFICATION: 'CLEAR_CART_SUCCESS_NOTIFICATION',
  CLEAR_CART_FAILURE_NOTIFICATION: 'CLEAR_CART_FAILURE_NOTIFICATION',
  ADD_FAVOURITE_TO_CART: 'ADD_FAVOURITE_TO_CART',
  CREATE_ORDER_SUCCESS: 'CREATE_ORDER_SUCCESS',
  CREATE_ORDER_FAILURE: 'CREATE_ORDER_FAILURE',
  CREATE_PURCHASER_SCHEDULE_ORDER_SUCCESS:
    'CREATE_PURCHASER_SCHEDULE_ORDER_SUCCESS',
  CREATE_PURCHASER_SCHEDULE_ORDER_FAILURE:
    'CREATE_PURCHASER_SCHEDULE_ORDER_FAILURE',
  CREATE_FAVOURITE_SUCCESS: 'CREATE_FAVOURITE_SUCCESS',
  CREATE_FAVOURITE_FAILURE: 'CREATE_FAVOURITE_FAILURE',
  UPDATE_FAVOURITE_SUCCESS: 'UPDATE_FAVOURITE_SUCCESS',
  UPDATE_FAVOURITE_FAILURE: 'UPDATE_FAVOURITE_FAILURE',
  DELETE_FAVOURITE_SUCCESS: 'DELETE_FAVOURITE_SUCCESS',
  DELETE_FAVOURITE_FAILURE: 'DELETE_FAVOURITE_FAILURE',
  NOTIFY_EXPORT_SUCCESS: 'NOTIFY_EXPORT_SUCCESS',
  NOTIFY_EXPORT_ERROR: 'NOTIFY_EXPORT_ERROR',
  ADD_UNAVAILABLE_PRODUCT: 'ADD_UNAVAILABLE_PRODUCT',
  MOV_CART_ERROR: 'MOV_CART_ERROR',
  CART_APPROVAL_SUCCESS: 'CART_APPROVAL_SUCCESS',
  CART_APPROVAL_ERROR: 'CART_APPROVAL_ERROR',
  CART_REMINDER_SUCCESS: 'CART_REMINDER_SUCCESS',
  CART_REMINDER_ERROR: 'CART_REMINDER_ERROR',
  TERMS_AND_CONDITIONS_ACCEPTANCE_FAILURE:
    'TERMS_AND_CONDITIONS_ACCEPTANCE_FAILURE',
  CART_FETCH_FAILURE: 'CART_FETCH_FAILURE',
  SCHEDULED_ORDER_REINSTATE_SUCCESS: 'SCHEDULED_ORDER_REINSTATE_SUCCESS',
  SCHEDULED_ORDER_REINSTATE_FAILURE: 'SCHEDULED_ORDER_REINSTATE_FAILURE',
  SCHEDULED_ORDER_CANCEL_SUCCESS: 'SCHEDULED_ORDER_CANCEL_SUCCESS',
  SCHEDULED_ORDER_CANCEL_FAILURE: 'SCHEDULED_ORDER_CANCEL_FAILURE',
  NOTIFICATION_DELAY: 3000,

  // PROFILE
  SEND_INITIAL_ANALYTICS: 'SEND_INITIAL_ANALYTICS',

  // PERMISSIONS
  CHECK_USER_PERMISSIONS: 'CHECK_USER_PERMISSIONS',
  PROFILE_VALIDITY_DAYS: 1,
  USER_PERMISSIONS: 'USER_PERMISSIONS',

  // HOME PAGE ORDERS
  HOME_NUM_ORDERS: 4,

  // SEARCH
  UPDATE_PRODUCT_SEARCH: 'UPDATE_PRODUCT_SEARCH',
  CLEAR_PRODUCT_SEARCH: 'CLEAR_PRODUCT_SEARCH',

  // MODAL
  OPEN_MODAL: 'OPEN_MODAL',
  CLOSE_MODAL: 'CLOSE_MODAL',

  // INFINITE SCROLL
  FAVOURITE_PRODUCTS_PAGESIZE: 500,
  CATEGORIES_PAGESIZE: 100,

  // DELIVERY DATE
  NO_DELIVERY_DATE: 'TBA',

  // OTHER
  BROWSER_TZ: Intl.DateTimeFormat().resolvedOptions().timeZone,

  // PROJECTIONS
  PROJECTIONS_URL: process.env.PROJECTIONS_URL || 'http://localhost:7778',
  PROJECTIONS_TOKEN:
    process.env.PROJECTIONS_TOKEN || 'wontYouTakeMeToFunkyTown',

  // API URLs
  API_BASE_URL: process.env.API_BASE_URL || 'http://localhost:3001',

  // FLAGS
  FLAGS_TIMEOUT: process.env.FLAGS_TIMEOUT || 1000,

  // STANDING ORDER
  FAVOURITE_ORDER: 'favourite',
  STANDING_ORDER_NEW: 'standing-order-new',
  STANDING_ORDER_EDIT: 'standing-order-edit',
  STANDING_ORDER_EDIT_INITIAL: 'standing-order-edit-initial',
  STANDING_ORDER_EDIT_ALL: 'standing-order-edit-all',
  PLACE_ORDER_NEW: 'place-order-new',
  PLACED_ORDER_EDIT: 'placed-order-edit',

  // payment methods
  PAYMENT_METHOD_CARD: 'card',
  PAYMENT_METHOD_DIRECT: 'direct',
  PAYMENT_METHOD_CARD_AND_DIRECT: 'card_and_direct',
  PAYMENT_METHOD_OTHER: 'other',
  VALID_DIRECT_PAYMENT_TYPES: ['direct', 'card_and_direct'],
  VALID_CARD_PAYMENT_TYPES: ['card', 'card_and_direct'],
});

// see note at top of file
